// Accepts `false` so the common `cond && 'class'` idiom type-checks; the loop
// below already skips every falsy input at runtime.
export function cn(...inputs: Array<string | Record<string, boolean> | false | undefined | null>) {
  const classes: string[] = []
  for (const inp of inputs) {
    if (!inp) continue
    if (typeof inp === 'string') {
      classes.push(inp)
    } else if (typeof inp === 'object') {
      for (const [k, v] of Object.entries(inp)) {
        if (v) classes.push(k)
      }
    }
  }
  return classes.join(' ')
}

